var React = require('react');
var moment = require('moment');
var _ = require('lodash');
var cx = require('classnames');
import { connect } from 'react-redux';
import Month from './Month.jsx';
import { nextMonth, previousMonth , firstAvailablePeriod } from './actions';
import ChevronUp from './chevronUp.jsx';
import ChevronDown from './chevronDown.jsx';

class InnerCalendar extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.nextMonth = this.nextMonth.bind(this);
        this.previousMonth = this.previousMonth.bind(this); 
        this.firstAvailablePeriod();
        
        this.state = {
            vertical: this.props.vertical
        };
    }

    firstAvailablePeriod() {
        this.props.dispatch(firstAvailablePeriod());
    }
    
    nextMonth() {
        this.props.dispatch(nextMonth());
    }

    previousMonth() {
        this.props.dispatch(previousMonth());
    }

    /**
     * Responsible of rendering a table for each month
     */
    render() { 
        const firstDay1 = moment.utc().month(0).date(1).year(this.props.year).startOf('day').add(0 + this.props.firstMonth,'month');
        const firstDay2 = moment.utc().month(0).date(1).year(this.props.year).startOf('day').add(1 + this.props.firstMonth,'month');
        const classMonth = cx('month-container', this.state.vertical ? 'col-xs-12 width-100': 'col-xl-6 col-lg-6 col-md-6 col-xs-6');

	if (this.state.vertical) { 
        return(
           <div className="row">
                <div className={classMonth}>
                    <div className="my-4 font-120 flex">
                        <div className="flex-1 flex pointer select-none justify-fstart" >
                            <div className="font-70 absolute pointer underline" style={{top:"-25px", left:"0px", width:"fit-content", margin:"0px 5px 0px 0px"}} onClick={this.previousMonth}>{firstDay1.clone().subtract(1,'month').format('MMM Y')}</div>
                            <div className="font-160" style={{border:"1px solid #eee", borderRadius:"50%",padding:"10px", width:"fit-content", marginLeft:"5px"}} onClick={this.previousMonth}>&#8592;</div>
                        </div>
                        <div className="flex-1" style={{padding:"10px"}}>{firstDay1.format('MMM Y')}</div>
                        <div className="flex-1 flex pointer select-none justify-fend" >
                            <div className="font-70 absolute pointer underline" style={{top:"-25px", right:"0px", width:"fit-content", margin:"0px 0px 0px 5px"}} onClick={this.nextMonth}>{firstDay1.clone().add(1,'month').format('MMM Y')}</div>
                            <div className="font-160"  style={{border:"1px solid #eee", borderRadius:"50%",padding:"10px", width:"fit-content",  marginRight:"5px"}} onClick={this.nextMonth}>&#8594;</div>
                        </div>
                    </div>
                    <Month 
                    firstDay={firstDay1}
                    interactive={this.props.interactive}
                    refresh={this.props.refresh}
                    selector={this.props.selector}
                    static={this.props.static}        
                    />
                </div>
	    </div>
            );
	}
	else { 
        return (
            <div style={this.props.popupcalendar ? {margin: "0px 40px 0px 20px"} : {}}>
                <div className="row">
                    <div className={classMonth}>
                        <div className="month-title ucfirst flex justify-content-start">
                            { this.state.vertical ?
                                <div className="chevronup" onClick={this.previousMonth} onTouchStart={this.previousMonth}>
                                    <ChevronUp/>
                                </div>
                                :
                                <div className="width-50 flex">
                                    <div className="font-70 absolute pointer underline" style={{top:"-25px", left:"-5px", width:"fit-content"}} onClick={this.previousMonth}>{firstDay1.clone().subtract(1,'month').format('MMM Y')}</div>
                                    <div className="previous-month font-160 absolute mr-2 valign-middle pointer select-none " style={{left:"0px"}}  onClick={this.previousMonth}>&#8592;</div>
                                </div>
                            }
                            <div className="ucfirst width-100">{firstDay1.format('MMM Y')}</div>
                        </div>
                        <Month 
                        firstDay={firstDay1}
                        interactive={this.props.interactive}
                        refresh={this.props.refresh}
                        selector={this.props.selector}
                        static={this.props.static}
                        />
                    </div>
                    <div className={classMonth}>
                        <div className="month-title flex">
                            <div className="ucfirst width-100">{firstDay2.format('MMM Y')}</div>
                            { !this.state.vertical && 
                                <div className="width-50 flex">
                                    <div className="font-70 absolute  pointer underline"  style={{top:"-25px",  right:"-5px", width:"fit-content"}} onClick={this.nextMonth}>{firstDay2.clone().add(1,'month').format('MMM Y')}</div>
                                    <div className="next-month font-160 absolute ml-2 valign-middle pointer select-none" style={{right:"0px"}}  onClick={this.nextMonth}>&#8594;</div>
                                </div>
                            }
                        </div>
                        <Month 
                        firstDay={firstDay2}
                        interactive={this.props.interactive}
                        refresh={this.props.refresh}
                        selector={this.props.selector}
                        static={this.props.static}
                        />
                        { this.state.vertical &&
                            <div className="chevrondown" onClick={this.nextMonth} onTouchStart={this.nextMonth}>
                                <ChevronDown/>
                            </div>
                        }
                    </div>
                </div>
            </div>
            );
	 }
    }

}

const mapStateToProps = (state) => ({
    vertical: state.calendarStore.vertical,
    year: state.calendarStore.year,
    firstMonth: state.calendarStore.firstMonth,
});

export default connect(mapStateToProps)(InnerCalendar);
